module.exports = __webpack_public_path__ + "780e4a4fd5ad4036e82ba4a07060192b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/lungwort.jpg
 ** module id = 453
 ** module chunks = 0
 **/